import { EventHighlight } from "@jesus-central-church/ui";
import type { SbEventHighlight } from "@storyblok/types/287435740670216/storyblok-components";
import { getAllUpcomingEvents } from "../lib/events";
import { getStoriesByUuids } from "../lib/storyblok";

export async function EventHighlightComponent({
  blok,
  pageData,
}: {
  blok: SbEventHighlight;
  pageData: { locale: string };
}) {
  // Fetch events based on configuration
  const events =
    !blok.events || blok.events.length === 0
      ? await getAllUpcomingEvents(
          pageData.locale,
          blok.filterByType?.toString(),
        )
      : await getStoriesByUuids(blok.events as string[]);

  // Don't render if no events found
  if (events.length === 0) return null;

  const highlightEvents = events.slice(0, 3);

  return (
    <EventHighlight
      backgroundColor={blok.backgroundColor as string}
      textColor={blok.textColor as string}
      title={blok.title}
      description={blok.description as string}
      events={highlightEvents}
    />
  );
}
